import { getGutsColumns, getParkFactorsColumns, getExpectedRunsColumns } from "../../config/columns";

export const ENDPOINTS = {
  guts: "/api/guts",
  park_factors: "/api/park_factors",
  expected_runs: "/api/expected_runs",
};

export const COLUMN_MAP = {
  guts: getGutsColumns,
  park_factors: getParkFactorsColumns,
  expected_runs: getExpectedRunsColumns,
};

export const ALLOWED_DATA_TYPES = ["guts", "park_factors", "expected_runs"];
